module.exports = require("babel-core/polyfill");



/*****************
 ** WEBPACK FOOTER
 ** /home/rengasturku/nettivanne/~/babel/polyfill.js
 ** module id = 589
 ** module chunks = 0 1 4 5 6 7 8
 **/